import { PhotosRemoveCurrentProfilePhotoReducer } from './types';

export const photosRemoveCurrentProfilePhotoReducer: PhotosRemoveCurrentProfilePhotoReducer =
  (state, action) => {
    return {
      ...state,
      currentProfilePhotos: state.currentProfilePhotos?.filter(
        (photo) => photo.id !== action.payload
      ),
    };
  };
